/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type PlatformProductPaginatedProperty =
  typeof PlatformProductPaginatedProperty[keyof typeof PlatformProductPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformProductPaginatedProperty = {
  PLATFORM_NAME: 'PLATFORM_NAME',
  ALIAS: 'ALIAS',
  CREATED_AT: 'CREATED_AT',
} as const;
